import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import { IcoDotSmall16 } from '@onefootprint/icons';
import type { Playbook } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import Actions from '../row/actions';
type MobileRowProps = {
  playbook: Playbook;
};
const MobileRow = t0 => {
  const $ = _c(46);
  const {
    playbook
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "table.row"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbooks", t1);
  const {
    formatDateWithTime
  } = useIntl();
  const {
    publishedVersion: t2,
    activeDeployment: t3,
    hasProdOnboarding
  } = playbook;
  const {
    name,
    kind,
    status
  } = t2;
  const {
    createdAt
  } = t3;
  let t4;
  if ($[1] !== t) {
    t4 = t(_temp);
    $[1] = t;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t) {
    t5 = t(_temp2);
    $[3] = t;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t(_temp3);
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t) {
    t7 = t(_temp4);
    $[7] = t;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t) {
    t8 = t(_temp5);
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = {
      kyc: t4,
      kyb: t5,
      auth: t6,
      document: t7,
      bank_linking: t8
    };
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const kindLabel = t9[kind];
  let t10;
  if ($[17] !== name) {
    t10 = <p className="min-w-0 text-label-2">{name}</p>;
    $[17] = name;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== hasProdOnboarding || $[20] !== t) {
    t11 = hasProdOnboarding && <IcoDotSmall16 color="success" aria-label={t(_temp6)} className="shrink-0" />;
    $[19] = hasProdOnboarding;
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <div className="flex items-center gap-1">{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = status === "disabled" ? "text-error" : undefined;
  let t14;
  if ($[25] !== status || $[26] !== t) {
    t14 = status === "enabled" ? t(_temp7) : t(_temp8);
    $[25] = status;
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = <span className={t13}>{t14}</span>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== createdAt || $[32] !== formatDateWithTime) {
    t16 = formatDateWithTime(new Date(createdAt));
    $[31] = createdAt;
    $[32] = formatDateWithTime;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== kindLabel || $[35] !== t15 || $[36] !== t16) {
    t17 = <p className="text-body-3 text-tertiary">{kindLabel} ·{" "}{t15}{" "}· {t16}</p>;
    $[34] = kindLabel;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t12 || $[39] !== t17) {
    t18 = <td><div className="flex flex-col gap-0.5 py-2">{t12}{t17}</div></td>;
    $[38] = t12;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== playbook.publishedVersion) {
    t19 = <td aria-label="actions"><Actions playbook={playbook.publishedVersion} /></td>;
    $[41] = playbook.publishedVersion;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t18 || $[44] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
};
export default MobileRow;
function _temp($) {
  return $.type.kyc;
}
function _temp2($_0) {
  return $_0.type.kyb;
}
function _temp3($_1) {
  return $_1.type.auth;
}
function _temp4($_2) {
  return $_2.type.document;
}
function _temp5($_3) {
  return $_3.type.bankLinking;
}
function _temp6($_4) {
  return $_4.type.production;
}
function _temp7($_5) {
  return $_5.status.enabled;
}
function _temp8($_6) {
  return $_6.status.disabled;
}